import fetcher from '../../lib/fetcher';
import { serializeQuery } from '../../lib/utils';

const useNotificationMarkAsRead = (id: number, notification: any) => {
  const notificationIds = notification.map((notification: any) => notification?.id);

  return fetcher.swr(
    `/filter-notifications/${id}/mark-as-read?${serializeQuery(notificationIds, 'itemIds')}`,
    {
      method: 'post',
      params: undefined,
    },
  );
};

export default useNotificationMarkAsRead;
